import { Instagram, Facebook, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="aq-bg-navy" style={{ padding: "56px 0 28px" }}>
      <div className="aq-container">
        <div className="grid sm:grid-cols-12 gap-8 items-start">
          <div className="sm:col-span-5">
            <div className="flex items-center gap-3">
              <img src="/brand/aquarius_logo_v2.png" alt="Aquarius Sport Fishing" className="h-12 w-auto" />
              <div>
                <div className="aq-serif text-xl" style={{ color: "var(--aq-foam)" }}>Aquarius Sport Fishing</div>
                <div className="aq-overline" style={{ fontSize: 9 }}>Ocho Rios · Jamaica</div>
              </div>
            </div>
            <p className="mt-5 text-sm max-w-sm" style={{ color: "rgba(246, 244, 238, 0.65)" }}>
              Sportfishing charters on a 55-foot Hatteras out of Ocho Rios Marina. Crewed,
              all-inclusive, marlin and tuna in season.
            </p>
          </div>

          <div className="sm:col-span-3">
            <div className="aq-overline">Visit</div>
            <ul className="mt-4 space-y-2 text-sm" style={{ color: "rgba(246,244,238,0.75)" }}>
              <li><a href="#vessel" className="hover:text-[var(--aq-gold-warm)]">The Vessel</a></li>
              <li><a href="#trips" className="hover:text-[var(--aq-gold-warm)]">Trips & Booking</a></li>
              <li><a href="#amenities" className="hover:text-[var(--aq-gold-warm)]">Amenities</a></li>
              <li><a href="#contact" className="hover:text-[var(--aq-gold-warm)]">Inquire</a></li>
            </ul>
          </div>

          <div className="sm:col-span-4">
            <div className="aq-overline">Connect</div>
            <div className="mt-4 flex items-center gap-3" data-testid="footer-socials">
              <a href="#" aria-label="Instagram" className="inline-flex items-center justify-center" style={{ width: 38, height: 38, border: "1px solid rgba(201,162,74,0.4)", color: "var(--aq-foam)" }}><Instagram size={16} /></a>
              <a href="#" aria-label="Facebook"  className="inline-flex items-center justify-center" style={{ width: 38, height: 38, border: "1px solid rgba(201,162,74,0.4)", color: "var(--aq-foam)" }}><Facebook size={16} /></a>
              <a href="mailto:hello@aquariuscharters.com" aria-label="Email" className="inline-flex items-center justify-center" style={{ width: 38, height: 38, border: "1px solid rgba(201,162,74,0.4)", color: "var(--aq-foam)" }}><Mail size={16} /></a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between" style={{ borderColor: "rgba(201,162,74,0.18)" }}>
          <p className="text-xs" style={{ color: "rgba(246, 244, 238, 0.55)" }}>
            © 2026 Aquarius Sport Fishing. All rights reserved.
          </p>
          <div className="flex gap-5 text-xs" style={{ color: "rgba(246, 244, 238, 0.55)" }}>
            <a href="#">Terms</a>
            <a href="#">Privacy</a>
            <a href="#">Waiver</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
